import ButtonPrimary from "componentsTemplate/Button/ButtonPrimary";
import Layout from "./layout";
import LayoutDashboard from "./layout/layout";
import Table from "components/table/table";
import { useEffect, useState } from "react";
import FormDinamic from "./cadEditDinamic";
import PerfilService from "../../services/PerfilService";
import { useParams } from "react-router-dom";

const UserDicas = () => {
  const [cadEditDinamic, setCadEditDinamic] = useState(false);
  const [user, setUser] = useState({} as any);
  const { id }: any = useParams();

  const [dados, setDados] = useState(null);

  useEffect(() => {
    getUser();
  }, []);

  const getUser = async () => {
    await PerfilService.getUserById(id)
      .then((response: any) => {
        setUser(response.data.user);
      })
      .catch((error: any) => {
        console.error(error);
      })
      .finally(() => {
        //setLoading(false); // end loading
      });
  };

  const acao = (dados: any) => {
    setDados(dados);
    setCadEditDinamic(true);
  };

  const acaoCadastrar = () => {
    setDados(null);
    setCadEditDinamic(true);
  };

  return (
    <Layout user={user}>
      <LayoutDashboard>
        {!cadEditDinamic ? (
          <>
            {/* <div className="flex-end">
              <ButtonPrimary
                className="md:col-span-2"
                type="button"
                onClick={() => acaoCadastrar()}
              >
                Nova Dica
              </ButtonPrimary>
            </div> */}
            <br />
            <div>
              <Table
                coluna1="Dicas"
                coluna2="Status"
                coluna3="Data"
                rota={`/posts/${id}/user-tips`}
                onlyView={true}                
                acao={acao}
                tipo="dicas"
              />
            </div>
          </>
        ) : (
          <FormDinamic
            nomeTela={"Dica"}
            tipoTela={1}
            acaoVoltar={setCadEditDinamic}
            dados={dados}
          />
        )}
      </LayoutDashboard>
    </Layout>
  );
};

export default UserDicas;
